import * as React from 'react';
import { IMaskInput } from 'react-imask';
import { NumericFormat } from 'react-number-format';
import Stack from '@mui/material/Stack';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "react-imask": { IMaskInput }, "react-number-format": { NumericFormat }, "@mui/material/Stack": Stack, "@mui/material/Input": Input, "@mui/material/InputLabel": InputLabel, "@mui/material/TextField": TextField, "@mui/material/FormControl": FormControl } } });
export default ClientProvider;
